<template lang="pug">
  layout

    //- Toolbar
    template(v-slot:toolbar)
      .navbar
        .navbar-item
          b-field(grouped group-multiline)
            b-select(placeholder="Категория" v-model="filter.category_id")
              option(:value='undefined')
              option(v-for="row in categories" :value='row.id') {{ row.name }}

            //- .control.is-flex: b-switch Необходимо изучить
            //- .control.is-flex: b-switch Избранное

            //- .control.is-flex: b-switch(v-model="hasSidebar") Sidebar
            //- .control.is-flex: b-switch(v-model="hasFooter") Statusbar

        .navbar-end
          //- [input] Поиск
          //- .navbar-item
            b-field
              b-input(placeholder="Поиск" rounded)

          //- [btn] Ноавый материал
          .navbar-item(v-if="$store.getters.user.can('Docs:create')")
            b-field
              b-button.is-primary(tag="router-link" :to="{name: 'docs.create'}")
                b-icon(icon="plus")
                span Новый материал

    //- Sidebar
    //- template(v-slot:sidebar )
      span(v-for="row in categories" :value='row.id') {{ row.name }}

    //- Statusbar
    //- template(v-slot:statusbar v-if="hasFooter")
      .navbar
        .navbar-item ok
        .navbar-item ok

    //- Content
    template(v-slot:content)
      b-table.is-clickable(:data='filteredContent' @click="onRowClick" hoverable striped)

        b-table-column(field="id" label="ID" width="40" sortable numeric v-slot="{row}") {{ row.id }}

        b-table-column(field="name" label="Название" sortable v-slot="{row}")
          b-icon(v-if="row.file_type" :icon="row.file_type.icon" :type="row.file_type.style")
          strong(v-if="row.isTarget")  {{ row.name }}
          span(v-else)  {{ row.name }}

        b-table-column(field="category.name" label="Категория" sortable v-slot="{row}") {{ row.category ? row.category.name : '' }}

        b-table-column(field="typeName" label="Тип документа" sortable v-slot="{row}") {{ row.typeName }}

        b-table-column(field="comments" label="Коментарии" sortable v-slot="{row}")
          b-taglist(v-if="row.comments" attached)
            b-tag {{ row.comments }}
            b-tag.is-success(v-if="row.newComments") {{ row.newComments }}

        b-table-column(field="isTarget" label="План" sortable numeric v-slot="{row}")
          .is-pulled-right
            //- b-tag.is-info(v-if="row.isNew") Новый
            .tag.is-warning.is-rounded(v-if="row.isTarget") Изучить до 15 мая
            .tag.is-success.is-rounded(v-if="row.isTargetSuccess")
              b-icon(icon="checkbox-marked-circle-outline" size="is-small")
              span Изучить до 15 мая

        //- b-table-column(field="progress" label="Прогресс" sortable v-slot="{row}")
          div(:class="row.isComplete ? 'has-text-success' : row.isUnread ? 'has-text-grey' : ''")
            b-icon(:icon='progressIcon(row.progress)')
            | {{ row.progress }}%


</template>

<script>
import db from '@/db';
import Document from '@/models/Document';

export default {
  name: 'view-docs-index',

  components: {},

  data: () => ({
    filter: {},
    hasSidebar: false,
    hasFooter: false,
    documents: Document.collection(),
    // data: db.docs,
    categories: db.categories,
  }),

  computed: {
    filteredContent() {
      return this.documents.items.filter(
        ({ category_id }) => !this.filter.category_id || category_id == this.filter.category_id
      );
    },
  },

  methods: {
    onRowClick({ id }) {
      this.$router.push({ name: 'docs.view.read', params: { id } });
    },
    progressIcon(progress) {
      const iconIndex = Math.floor((progress / 100) * 8);
      return iconIndex ? `circle-slice-${iconIndex}` : 'circle-outline';
    },
  },
  created() {
    this.documents.$fetch({ include: 'category' });
  },
};
</script>
